export const ONE_DAY_IN_MS = 24 * 60 * 60e3; // 24h
export const FIRST_DAY_DISCOUNT_AVAILABLE_FOR_MS = ONE_DAY_IN_MS;
